export const navOpenSmallScreenContainer = {
  minWidth: '700px',
  width: '100%',
  height: '95vh',
  marginTop: '2vh',
}

export const navOpenLargeScreenContainer = {
  width: '86vw',
  height: '95vh',
  marginTop: '2vh',
}

export const navClosedContainer = {
  width: '100%',
  minWidth: '530px',
  height: '95vh',
  marginTop: '2vh',
}

export const gridByPresentage = {
  width: '100%',
  height: '100%',
}

export const inputBoxWrapper = {
  display: 'flex',
  gap: '10px',
  alignItems: 'flex-start',
  justifyContent: 'flex-end',
}

export const smallScreenGrid = {
  backgroundColor: 'white',
  height: '100%',
  paddingBottom: '130px',
  borderRadius: '15px',
}

export const dashWrapperBox = {
  paddingTop: '7px',
}

export const inputBoxWrapperWidth = {
  width: '25%',
}

export const nameTypographyWidth = {
  width: '15%',
  minWidth: '20px',
}

export const largeScreenGrid = {
  backgroundColor: 'white',
  height: '100%',
  borderRadius: '15px',
}

export const navOpenSmallScreenCard = {
  height: '100%',
  width: '78%',
}

export const navOpenLargeScreenCard = {
  height: '100%',
  width: '86%',
}

export const navClosedSmallScreenCard = {
  height: '100%',
  width: '92%',
}

export const navClosedLargeScreenCard = {
  height: '100%',
  width: '97%',
}

export const restoreBtn = {
  width: 'auto',
  marginLeft: '30px',
}

export const updateBtn = {
  width: '230px',
  marginRight: '30px',
}

export const rightHelperTextStyle = {
  '& .MuiFormHelperText-root': {
    color: 'red',
    fontSize: '0.75rem',
    whiteSpace: 'nowrap',
    width: '100%',
    justifyContent: 'flex-end',
    textAlign: 'left',
    direction: 'rtl',
    transform: 'translateX(-10px)',
    maxHeight: '4px',
    minHeight: '4px',
  },
}

export const rightHelperWarningTextStyle = {
  '& .MuiFormHelperText-root': {
    color: 'orange',
    fontSize: '0.75rem',
    whiteSpace: 'nowrap',
    width: '100%',
    justifyContent: 'flex-end',
    textAlign: 'left',
    direction: 'rtl',
    transform: 'translateX(-10px)',
    maxHeight: '4px',
    minHeight: '4px',
  },
}

export const leftHelperTextStyle = {
  '& .MuiFormHelperText-root': {
    color: 'red',
    fontSize: '0.75rem',
    width: '100%',
    justifyContent: 'flex-start',
    textAlign: 'left',
    transform: 'translateX(-10px)',
    lineHeight: 1,
    maxHeight: '4px',
    minHeight: '4px',
  },
}

export const leftHelperWarningTextStyle = {
  '& .MuiFormHelperText-root': {
    color: 'orange',
    fontSize: '0.75rem',
    width: '100%',
    justifyContent: 'flex-start',
    textAlign: 'left',
    transform: 'translateX(-10px)',
    lineHeight: 1,
    maxHeight: '4px',
    minHeight: '4px',
  },
}
